import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Gelombang from "../../../assets/images/login-gelombang.svg";
import ImageFamily from "../../../assets/images/family.svg";

import {
  Button,
  FormHelperText,
  CircularProgress,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@material-ui/core";

import { Visibility, VisibilityOff, Lock } from "@material-ui/icons";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

import PageLoading from "../../../components/appLoading";
import useStyles from "./styles";
import Header from "../../../components/molecules/navbarLogReg";
import Header1 from "../../../components/molecules/LoginNav/header";

import Footer from "../../../components/molecules/LoginNav/footer";

import {
  auth,
  firefunctions,
  useFirebase,
} from "../../../components/firebase/FirebaseProvider";

const Reset = () => {
  const classes = useStyles();
  const [year] = useState(new Date().getFullYear());
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.up("tablet"));
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useFirebase();

  const [isSubmitting, setSubmitting] = useState(false);

  const [values, setValues] = useState({
    password: "",
    repassword: "",
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const rehandleClickShowPassword = () => {
    setValues({ ...values, reshowPassword: !values.reshowPassword });
  };

  const rehandleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStatus: false,
      errorType: "",
      errorMessage: "",
    });
  };

  const handleError = (err) => {
    setValues({
      ...values,
      errorStatus: true,
      errorType:
        err === "Password wajib diisi"
          ? "password kosong"
          : err === "Ulangi Password wajib diisi"
          ? "repassword kosong"
          : err === "Password tidak sama"
          ? "beda"
          : err === "Password minimal 8 karakter"
          ? "pendek"
          : null,
      errorMessage: err,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      if (!values.password) {
        throw new Error("Password wajib diisi");
      } else if (!values.repassword) {
        throw new Error("Ulangi Password wajib diisi");
      } else if (values.password !== values.repassword) {
        throw new Error("Password tidak sama");
      } else if (values.password.length < 8 || values.repassword.length < 8) {
        throw new Error("Password minimal 8 karakter");
      }

      const { password } = values;

      const resetPassword = firefunctions.httpsCallable("setPassword");
      await resetPassword({ password });

      history.push("/");
      setSubmitting(false);

      enqueueSnackbar("Berhasil memperbarui password!", {
        variant: "success",
      });
    } catch (err) {
      setSubmitting(false);
      handleError(err.message);
    }
    setSubmitting(false);
  };

  if (loading) {
    return <PageLoading />;
  }

  const logout = () => {
    auth.signOut();
    history.push("/login");
  };

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        {matches ? (
          <Header1 nameStatus={"Reset Password"} />
        ) : (
          <Header nameStatus={"Reset Password"} />
        )}

        <div className={classes.container_two}>
          <Grid container spacing={0} alignItems="center">
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              className={classes.image_background}
            >
              <img
                src={ImageFamily}
                alt="logo"
                style={{ marginLeft: "20%", width: "65%" }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ zIndex: "10" }}>
              <div className={classes.box_body}>
                <div className={classes.box_head}>
                  <div className={classes.box_head_text}>
                    <h1>Lupa Password?</h1>
                    <p>Buat password baru untuk masuk ke Tokorame</p>
                  </div>
                </div>
                <form className={classes.box_form} onSubmit={handleSubmit}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.input_form}
                    style={{ marginBottom: "25px" }}
                    error={
                      values.errorStatus
                        ? values.errorType === "beda" ||
                          values.errorType === "password kosong" ||
                          values.errorType === "pendek"
                          ? values.errorStatus
                          : null
                        : null
                    }
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      Password Baru
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      label="Password Baru"
                      type={values.showPassword ? "text" : "password"}
                      value={values.password}
                      autoFocus={values.autoFocus}
                      onChange={handleChange("password")}
                      disabled={isSubmitting}
                      startAdornment={
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {values.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                      placeholder="Password Baru"
                    />
                    {values.errorStatus ? (
                      values.errorType === "beda" ||
                      values.errorType === "password kosong" ||
                      values.errorType === "pendek" ? (
                        <FormHelperText>{values.errorMessage}</FormHelperText>
                      ) : null
                    ) : null}
                  </FormControl>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.input_form}
                    style={{ marginBottom: "25px" }}
                    error={
                      values.errorStatus
                        ? values.errorType === "beda" ||
                          values.errorType === "repassword kosong" ||
                          values.errorType === "pendek"
                          ? values.errorStatus
                          : null
                        : null
                    }
                  >
                    <InputLabel htmlFor="outlined-adornment-password-1">
                      Ulangi Password Baru
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password-1"
                      label="Ulangi Password Baru"
                      type={values.reshowPassword ? "text" : "password"}
                      value={values.repassword}
                      autoFocus={values.autoFocus}
                      onChange={handleChange("repassword")}
                      disabled={isSubmitting}
                      startAdornment={
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={rehandleClickShowPassword}
                            onMouseDown={rehandleMouseDownPassword}
                            edge="end"
                          >
                            {values.reshowPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                      placeholder="Ulangi Password Baru"
                    />
                    {values.errorStatus ? (
                      values.errorType === "beda" ||
                      values.errorType === "repassword kosong" ||
                      values.errorType === "pendek" ? (
                        <FormHelperText>{values.errorMessage}</FormHelperText>
                      ) : null
                    ) : null}
                  </FormControl>
                  <div className={classes.bottom_form}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      style={{
                        position: "relative",
                        width: "100%",
                        letterSpacing: "1px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                        marginTop: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      {!isSubmitting ? (
                        "perbarui password"
                      ) : (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </Button>
                    <h5
                      style={{
                        color: "#00000040",
                        fontSize: matches ? "" : 17,
                        textAlign: "center",
                        marginTop: "0",
                      }}
                    >
                      Tidak mau ganti password?
                      <Button
                        style={{
                          color: "#5675D3",
                          fontSize: 12,
                          backgroundColor: "transparent",
                          textTransform: "capitalize",
                        }}
                        onClick={logout}
                      >
                        Batalkan
                      </Button>
                    </h5>
                  </div>
                </form>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.body}>
          <span className={classes.copyright} style={{ bottom: "50px" }}>
            © Hak Cipta PT. Tokorame Anugerah Sejahtera - {year}
          </span>
          <div className={classes.gelombang}>
            <img src={Gelombang} alt="gelombang" />
          </div>
        </div>
      </div>
      {matches ? <Footer /> : null}
    </div>
  );
};

export default Reset;
